import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { LocationRow, LocationSku } from './itemsByLocation';

const col = createColumnHelper<LocationRow>();

const LOCATION_W = 220;
const HUB_W = 160;
const SKU_W = 130;

/**
 * Columns for the Items by Locations pivot (ClickUp 86bbmcuwa): the two
 * labelling columns, then one per SKU.
 *
 * Location and Wash Hub are pinned. The SKU columns make this table far wider
 * than the screen, and once those two scroll away every row is a line of
 * numbers with nothing saying which location it belongs to.
 */
export const buildItemsByLocationColumns = (
  skus: LocationSku[],
): ColumnDef<LocationRow, any>[] => [
  col.accessor('location', {
    header: 'Location',
    size: LOCATION_W,
    minSize: LOCATION_W,
    meta: { pinned: true },
  }),
  col.accessor('washHub', {
    header: 'Wash Hub',
    size: HUB_W,
    minSize: HUB_W,
    meta: { pinned: true },
  }),
  ...skus.map((sku) =>
    col.accessor((row) => row.counts[sku._id] || 0, {
      id: sku._id,
      header: sku.name,
      size: SKU_W,
      minSize: SKU_W,
      meta: { align: 'right' as const },
      cell: (info) => (info.getValue() as number).toLocaleString(),
    }),
  ),
];
